import { connect } from "helpers/redux";

export default function (Component) {
    const mapState = (state) => ({
        profile: state.profile.profile,
        organization: state.profile.organization,
        roles: state.profile.roles,
    });
    return connect(mapState, () => ({}))(Component);
}
